const getFiltersConfig = ({ featureFlags = {}, isB2B, isSearch = false }) => {
    const filtersConfig = {
        brand_name: {
            attributeName: 'brand_name',
            id: 'brand_names',
            labelKey: {
                label: {
                    id: 'listing.filters.facets.brand_names.label',
                    defaultMessage: 'Brands',
                    description: 'Label of the brands filter',
                },
            },
            type: 'checkbox',
            order: featureFlags.brandNameIndex || 1,
        },
        is_mmf: {
            attributeName: 'is_mmf',
            id: 'mmf',
            labelKey: {
                title: {
                    id: 'listing.filters.facets.mmf.title',
                    defaultMessage: 'Shipping method',
                    description: 'Title of bingo filter',
                },
                label: {
                    id: 'listing.filters.facets.mmf.label',
                    defaultMessage: 'Bingo ! Expédié par ManoMano',
                    description: 'Title of bingo filter',
                },
            },
            type: 'bool',
            order: 1.2,
        },
        has_free_delivery: {
            attributeName: 'has_free_delivery',
            id: 'fd',
            labelKey: {
                label: {
                    id: 'listing.filters.facets.fd.label',
                    defaultMessage: 'Free delivery',
                    description: 'Label of free delivery filter',
                },
            },
            type: 'bool',
            order: 2.5,
            bundledIn: 'delivery',
        },
        has_1day_delivery: {
            attributeName: 'has_1day_delivery',
            id: '1dd',
            labelKey: {
                label: {
                    id: 'listing.filters.facets.1dd.label',
                    defaultMessage: '1 day delivery',
                    description: 'Label of 1 day delivery filter',
                },
            },
            type: 'bool',
            order: 2.6,
            bundledIn: 'delivery',
        },
        has_relay_delivery: {
            attributeName: 'has_relay_delivery',
            id: 'rd',
            labelKey: {
                label: {
                    id: 'listing.filters.facets.rd.label',
                    defaultMessage: 'Delivery to a relay point',
                    description: 'Label of relay delivery filter',
                },
            },
            type: 'bool',
            order: 2.7,
            bundledIn: 'delivery',
        },
        has_3x_payment: {
            attributeName: 'has_3x_payment',
            id: 'mp',
            labelKey: {
                label: {
                    id: 'listing.filters.facets.mp.label',
                    defaultMessage: '3x payment without fees',
                    description: 'Label of 3x fee payment filter',
                },
            },
            type: 'bool',
            order: featureFlags.has3xPaymentIndex || 4,
        },
        seller_name: {
            attributeName: 'seller_name',
            id: 'seller_names',
            labelKey: {
                label: {
                    id: 'listing.filters.facets.seller_names.label',
                    defaultMessage: 'Sellers',
                    description: 'Label of sellers filter',
                },
            },
            type: 'checkbox',
            order: featureFlags.sellerNameIndex || 5,
        },
        price: {
            attributeName: 'price',
            id: 'price',
            labelKey: {
                label: {
                    id: 'listing.filters.facets.price.label',
                    defaultMessage: 'Price (€)',
                    description: 'Label of price filter',
                },
            },
            type: 'range',
            order: featureFlags.priceIndex || 0,
        },
        delivery: {
            labelKey: {
                label: {
                    id: 'listing.filters.facets.delivery.label',
                    defaultMessage: 'Delivery',
                    description: 'Label of delivery filter',
                },
            },
            type: 'toggleList',
            id: 'delivery',
            attributeName: 'delivery',
            order: featureFlags.deliveryIndex || 3,
        },
        'categories.last': {
            labelKey: {
                label: {
                    id: 'listing.filters.facets.category_names.label',
                    defaultMessage: 'Categories',
                    description: 'Label of categories last filter',
                },
            },
            type: 'checkbox',
            id: 'category_names',
            attributeName: 'categories.last',
            ...(featureFlags.showCategoriesFilterOnSearch ? { order: -1 } : {}),
        },
        'categories.l2.id': {
            type: 'menu',
            id: 'category.l2',
            attributeName: 'categories.l2.id',
        },
        'categories.l3.id': {
            type: 'menu',
            id: 'category.l3',
            attributeName: 'categories.l3.id',
        },
    };
    if (isB2B)
        filtersConfig.has_pro_conditions = {
            attributeName: 'has_pro_conditions',
            id: 'pro',
            labelKey: {
                label: {
                    id: 'listing.filters.facets.pro.label',
                    defaultMessage: 'Products reserved for pros',
                    description: 'Label pro condition filter',
                },
                title: {
                    id: 'listing.filters.facets.pro.title',
                    defaultMessage: 'Catalog',
                    description: 'Title pro condition filter',
                },
            },
            type: 'bool',
            order: 0,
        };

    if (isSearch)
        filtersConfig['categories.last_id'] = {
            labelKey: {
                label: {
                    id: 'listing.filters.facets.category_id.label',
                    defaultMessage: 'Categories',
                    description: 'Label of categories last id filter',
                },
            },
            type: 'categoryList',
            id: 'category_id',
            attributeName: 'categories.last_id',
            order: 100,
        };

    return filtersConfig;
};

export default getFiltersConfig;
